module.exports = __webpack_public_path__ + "static/media/Leonie.0e81f58c.JPG";